module.exports = "../study/imgs/maps/Nagano/S8/Agriculture/Rice/Nagano_Rice_MIROC5_RCP45_End.png";